<template>
    <v-card :loading="isLoading">
        <v-card-subtitle class="d-flex align-center">
            Additional expenses <v-spacer /><v-btn @click="showAddDialog = true"
                >Add</v-btn
            ></v-card-subtitle
        >
        <v-divider />
        <v-card-text>
            <div
                outlined
                v-for="i in serverData.expenses"
                :key="i.id"
                class="mb-4"
            >
                <AdditionalExpenseCard
                    :parentData="i"
                    :order-id="orderId"
                    @refresh="fetchAdditionalExpenses"
                />
            </div>
            <div v-if="serverData.expenses.length <= 0">
                <v-sheet>
                    <span class="text-color-black-100">
                        No additional expense yet
                    </span>
                </v-sheet>
            </div>
        </v-card-text>
        <AdditionalExpenseFormDialog
            @close="showAddDialog = false"
            :visible="showAddDialog"
            :order-id="orderId"
            v-if="showAddDialog"
            @refresh="fetchAdditionalExpenses"
        />
    </v-card>
</template>
<script>
import additionalExpApi from '@/api/additionalExpenseApi';
export default {
    props: {
        orderId: {
            type: Number,
            required: true
        }
    },
    components: {
        AdditionalExpenseFormDialog: () =>
            import('@/components/AdditionalExpenseFormDialog'),
        AdditionalExpenseCard: () =>
            import('@/components/AdditionalExpenseCard.vue')
    },
    data() {
        return {
            showAddDialog: false,
            isLoading: false,
            serverData: {
                expenses: []
            },
            additionalExpenseDialogData: {
                amount: null,
                description: null,
                addExpId: null
            }
        };
    },
    mounted() {
        this.fetchAdditionalExpenses();
    },
    methods: {
        async fetchAdditionalExpenses() {
            this.showAddDialog = false;
            try {
                this.isLoading = true;
                var k = await additionalExpApi.getAdditionalExpenses(
                    this.orderId
                );
            } finally {
                this.isLoading = false;
            }
            this.serverData.expenses = k.data;
        }
    }
};
</script>
